import Player from '@vimeo/player';

const isPortal = !!document.getElementsByClassName('portal-page').length;
export default class VimeoPlayerScoll extends Player {
	static players = [];

	static {
		this.bind();
	};

	constructor(element, options) {
	    super(element, options);
	    this.el = document.getElementById(element);
	    VimeoPlayerScoll.players.push(this);
	    VimeoPlayerScoll.playPause();
	}

	static bind() {
	    window.addEventListener('scroll', _.debounce(() => this.playPause(), 100));
	}

	static playPause() {
	    if (!isPortal) {
	        VimeoPlayerScoll.players.forEach((player) => {
	            this.inView(player.el) ? player.play() : player.pause();
	        });
	    }
	}

	static inView(el) {
	    const rect = el.getBoundingClientRect();
	    const elemTop = rect.top;
	    const elemBottom = rect.bottom;
	    return elemTop < window.innerHeight && elemBottom >= 0;
	}
}
